import { render, staticRenderFns } from "./BowButton.vue?vue&type=template&id=5a37ff3f&"
import script from "./BowButton.vue?vue&type=script&lang=js&"
export * from "./BowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowIcons: require('/workspace/components/atoms/BowIcons/BowIcons.vue').default})
